import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="24" height="24" rx="8" fill="#D3E8FC" />
    <path
      d="M16.1566 10.0312L17.5728 8.15131C17.7736 7.88488 17.806 7.53312 17.6568 7.23431C17.5076 6.9355 17.2079 6.75 16.8737 6.75H9C8.03487 6.75 7.25 7.53487 7.25 8.5V16.8125C7.25 17.0544 7.446 17.25 7.6875 17.25C7.929 17.25 8.125 17.0544 8.125 16.8125V13.3125H16.8741C17.2084 13.3125 17.5081 13.1266 17.6572 12.8282C17.8064 12.5298 17.7741 12.1781 17.5732 11.9112L16.1566 10.0312ZM8.125 12.4375V8.5C8.125 8.01744 8.51744 7.625 9 7.625H16.8741L15.2598 9.76787C15.1425 9.92362 15.1425 10.1384 15.2598 10.2942L16.8741 12.4371L8.125 12.4375Z"
      fill="#003477"
    />
    <path
      d="M8.125 12.4375V8.5C8.125 8.01744 8.51744 7.625 9 7.625H16.8741L15.2598 9.76787C15.1425 9.92362 15.1425 10.1384 15.2598 10.2942L16.8741 12.4371L8.125 12.4375Z"
      fill="#003477"
    />
  </svg>
);

const IconFilledFlag = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default IconFilledFlag;
